import { reactive } from 'vue';
import api from './apiClient';

// Ajustes generales del sitio (singleton en el backend)
export const getSiteSettings = async () => {
  try {
    const response = await api.get('/site-settings/');
    return response.data;
  } catch (error) {
    console.error('Error al obtener ajustes del sitio:', error);
    throw error;
  }
};

// Actualiza ajustes (solo admin)
export const updateSiteSettings = async (data) => {
  try {
    const response = await api.patch('/site-settings/', data);
    return response.data;
  } catch (error) {
    console.error('Error al actualizar ajustes del sitio:', error);
    throw error.response?.data || { error: 'Error al actualizar ajustes del sitio' };
  }
};

export const unlockMaintenance = async (password) => {
  try {
    const response = await api.post('/site-settings/', { password });
    return response.data;
  } catch (error) {
    console.error('Error al validar la contraseña de mantenimiento:', error);
    throw error;
  }
};

/* ---------------------------------------------------------------------
   Ajustes públicos compartidos (reactivos) para footer, home, etc.
   Se cargan una sola vez y se cachean en memoria; si el fetch falla (p. ej.
   migración pendiente) se mantienen los defaults para no romper la web.
   --------------------------------------------------------------------- */
const DEFAULTS = {
  instagram_url: 'https://instagram.com/heavensfruit.ar',
  instagram_handle: '@heavensfruit.ar',
};

const siteSettings = reactive({
  loaded: false,
  ...DEFAULTS,
});

export const useSiteSettings = () => siteSettings;

export const loadSiteSettings = async (force = false) => {
  if (siteSettings.loaded && !force) return siteSettings;

  try {
    const response = await api.get('/site-settings/');
    const data = response.data || {};
    siteSettings.instagram_url = data.instagram_url || DEFAULTS.instagram_url;
    siteSettings.instagram_handle = data.instagram_handle || DEFAULTS.instagram_handle;
    siteSettings.loaded = true;
  } catch (error) {
    console.error('Error al cargar ajustes públicos del sitio:', error);
  }

  return siteSettings;
};
